<template>
<v-container style="margin: 0px; padding: 0px; max-width:100%">
    <v-toolbar color="indigo" dark dense>
      <v-toolbar-title>{{args.desc}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
          <v-btn dark  text @click.native="close">Close</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div class="compact-form"  style="margin-left: 20px;">
      <v-layout row align-center  justify="center">
        <v-layout justify-end>
         <v-flex shrink>
        <v-btn color='blue' :disabled="!clientData.fname || !clientData.lname" @click="save">Save</v-btn>
      </v-flex>
        </v-layout>
         <v-flex xs12>
            <br />
            <h2 class="text-h4 pl-4">User Type</h2>
            <br />
          </v-flex>
         
      <v-radio-group v-model="mode" row class="pl-4">
        <v-radio label="Add New" value="new"></v-radio>
        <v-radio label="Edit Existing" value="existing"></v-radio>
      </v-radio-group>
      <v-flex xs12 class="pl-10">
      <v-autocomplete  
        style="margin: 0px; padding-top: 25px; padding-right: 20px;" 
        dense 
        v-if="mode == 'existing'" 
        outlined 
        clearable
        v-model='selectedUser' 
        :items="users" 
        label="Select User"
        item-text="fullName"
        item-value="_id"
      >
      <template slot="selection" slot-scope="data">
        {{ data.item.fname }} {{ data.item.lname}}
      </template>
      <template slot="item" slot-scope="data">
        {{ data.item.fname }} {{ data.item.lname}}
      </template>
      </v-autocomplete>
      </v-flex>
      </v-layout>
      <v-divider />
      <div id="orgSelection">
         <v-layout row align-center  justify="center">
         <v-flex xs12>
            <br />
            <h2 class="text-h4 pl-4">Select Org Type:</h2>
            <br />
          </v-flex>
          <v-radio-group v-model="orgmode" row class="pl-4">
        <v-radio label="Add New" value="new"></v-radio>
        <v-radio label="Use Existing" value="existing"></v-radio>
      </v-radio-group>
      <v-flex xs12 class="pl-10">
      <v-autocomplete
        style="margin: 0px; padding-top: 25px; padding-right: 20px;" 
        dense 
        v-if="orgmode == 'existing'" 
        outlined 
        clearable
        v-model='selectedOrg' 
        :items="orgs" 
        label="Select Org"
        item-text="fullName"
        item-value="_id"
      >
      </v-autocomplete>
      <v-text-field v-model="clientData.orgname" :disabled="disableOrg" dense label="Org Name" outlined />
      <v-autocomplete
        style="margin: 0px; padding-top: 25px; padding-right: 20px;" 
        dense 
        outlined 
        clearable
        v-model='selectedPlan' 
        :items="plans" 
        label="Select Subscription Plan"
        item-text="name"
        item-value="_id"
      >
      <template slot="selection" slot-scope="data">
                Plan: {{ data.item.name }} / Type:
                {{ data.item.otype }}
              </template>
              <template slot="item" slot-scope="data">
                Plan: {{ data.item.name }} / Type:
                {{ data.item.otype }}
              </template>
      </v-autocomplete>
      </v-flex>
         </v-layout>
      </div>
      <v-divider />
      <div id="clientsPeople">
        <v-layout row>
           <v-flex xs12>
            <br />
            <h2 class="text-h4 pl-4">User Information:</h2>
            <br />
          </v-flex>
        <v-flex class="pl-10">
        <v-text-field dense v-model="clientData.fname" label="First Name" outlined />
        <v-text-field dense v-model="clientData.mi" label="Middle Name" outlined />
        <v-text-field dense v-model="clientData.lname" label="Last Name" outlined />
        <v-text-field dense v-model="clientData.email" label="Email" outlined />
        </v-flex>
        </v-layout>
      </div>
      <v-divider />
      <v-flex xs12>
            <br />
            <h2 class="text-h4 pl-4">Access Information</h2>
            <br />
      </v-flex>
      <v-select class="pl-10" dense outlined v-model="clientData.role" :items="roles" label="Role"></v-select>
      <v-select class="pl-10"
              dense
              outlined
              v-model="access"
              :items="['Web UI', 'Mobile App']"
              multiple
              label="Allow login to:"
              :error-messages="access_error"
              >
            </v-select>
      </div>
      <v-divider />
       <div id="userHistory" v-if="existingUser">
        <v-layout row align-baseline>
          <v-flex xs12>
            <br />
            <h2 class="text-h4 pl-4">History</h2>
            <br />
            <v-flex xs12>
              <v-spacer></v-spacer>
              <server-table-component
                :rowProp="history"
                :schema="historySchema"
                :table="historySchema"
                embed
                class="pl-10"
                :editable="false"
              ></server-table-component>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
  </v-container>
</template>
<script>
import { sync } from "vuex-pathify"
import axiosInstances from "@/../../coreui/server/axiosInstances"
export default {
  props: ['args'],
  data: () => ({
    mode: 'new',
    orgmode: 'new',
    user: {},
    users: [],
    roles: ["Admin", "User", "Super"],
    selectedUser: null,
    clientData: {},
    userData: {props:{}},
    allowAccess: false,
    inactive: false,
    allowedFacilities: [],
    facilities: [],
    selectedFacility: null,
    modules: [],
    allowedModules: null,
    usStates: [],
    access: [],
    access_error: null,
    // New additions
    historySchema: "sch_set_history",
    history: [],
    existingUser: false,
    orgs: [],
    selectedOrg: null,
    selectedPlan: null,
    plans: [],
    disableOrg: false,
    changeDetected: false
  }),
  computed: {
    origLoggedinUser: sync('login/origLoggedinUser'),
    origLoggedinOrg: sync('login/origLoggedinOrg'),
    mqttTableUpdated: sync("mqtt/mqttTableUpdated")
  },
  watch: {
    mqttTableUpdated: {
      async handler(val){
        if(val === "new_account"){
          if(this.clientData.hasOwnProperty("_id")) await this.selectedUser(this.clientData["_id"])
        }

      }
    },
    mode: {
      async handler (val) {
        this.clear()
        if (val == 'new') {
        } else {
          let curUsers = await axiosInstances.loginServer.get('/dt/v1/new_account')
          this.users = curUsers.data
          this.existingUser = true
        }
      }
    },
    orgmode: {
      async handler(val){
        this.clear()
        if(val === "new"){

        } else {
          this.disableOrg = true
        }
      }
    },
    access: {
      immediate: true,
      handler (val) {
        this.access_error = val.length == 0 ? 'Select at least one' : null
      }

    },
    selectedUser: {
      async handler (val) {
        console.log(val)
        let userData = await axiosInstances.loginServer.get('/dt/v1/new_account/'+val)
          console.log('user data: ', userData)
          if (userData != null && userData.data != null) {
            this.clientData = userData.data
            this.allowAccess = true
            if (this.clientData.IsUsed == 'no') {
              this.inactive = true
            } else {
              this.inactive = false
            }
            this.history = this.clientData.history
            this.access = this.clientData.access
            this.role = this.clientData.role
            this.selectedPlan = this.clientData.plan
          }
        }
    },
    selectedOrg: {
      async handler(val) {
        let orgOBJ = this.orgs.find(x => x["_id"] === val)
        this.clientData.orgname = orgOBJ["fullName"]
        this.clientData.org=orgOBJ["name"]
      }
    },
    selectedPlan: {
      async handler(val){
        this.clientData.plan = val
      }
    }
  },
  methods: {
    close() {
      this.$router.go(-1)
    },
    async save () {
      //delete this.userData['password']
      let payload = {}
      for(const [key, value] of Object.entries(this.clientData)){
        if(key !== "history" && key !== "pass") payload[key] = value
      }
      payload.role = this.role
      payload.plan = this.selectedPlan
      payload.access = this.access
      console.log('Record to save: ', payload)
      if(payload.hasOwnProperty("_id")){
        await axiosInstances.loginServer.patch("/dt/v1/new_account/" + payload["_id"], payload)
      } else {
        await axiosInstances.loginServer.post("/dt/v1/new_account", payload)
      }
      

      //payload.clientData = this.clientData
      //payload.userData = this.strip(this.userData)
      //payload.access = this.access
      //payload.action = this.mode == 'new' ? 'customer_user_create' : 'customer_user_update'
      //console.log('payload: ', payload)
      //await this.origApiServer.post('/dt/v1/temp_settings_workflow', payload)
      //this.clear()
    },
    clear() {
      this.user = {}
      this.clientData = {}
      this.userData = {}
      this.tempData = {}
      this.access = []
      this.allowAccess = false
      this.disableOrg = false
    },
    strip (i) {
      let ni = {}
      ni.props = i.props
      ni.active = this.inactive ? 'no' : 'yes'
      return ni
    }
  },
  async mounted () {
    let orgs = await axiosInstances.loginServer.get('/dt/v1/org')
    let plans = await axiosInstances.loginServer.get('/dt/v1/auth_plans')
    if(orgs !== null && orgs.data !== null) this.orgs = orgs.data
    if(plans !== null && plans.data !== null) this.plans = plans.data
    this.roles = ['Admin', 'User']
    if (this.origLoggedinUser.role == 'super') {
      this.roles.unshift('super')
    }
  }
}
</script>
<style scoped>
.compact-form {
    transform: scale(0.95);
    transform-origin: left;
}
</style>